import { render, staticRenderFns } from "./StreamDownloadButton.vue?vue&type=template&id=130efea4&scoped=true&"
import script from "./StreamDownloadButton.vue?vue&type=script&lang=js&"
export * from "./StreamDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130efea4",
  null
  
)

export default component.exports